import React, { useState, useEffect } from 'react';
import MaxCharacter from './MaxCharacter';
import ToyImage from './ToyImage';
import words from '../data/words';

const CONFETTI_COUNT = 40;
const CONFETTI_COLORS = ['#EF2323','#FFD600','#4CAF50','#2196F3','#FF69B4','#FF9800','#9C27B0'];
const SHAPES = ['●', '■', '▲', '◆'];

function Confetti() {
  const pieces = Array.from({length: CONFETTI_COUNT}, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 2.5,
    duration: 2.5 + Math.random() * 2,
    color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
    shape: SHAPES[i % SHAPES.length],
    size: 10 + Math.random() * 14,
  }));

  return (
    <div style={{position:'absolute', inset:0, overflow:'hidden', pointerEvents:'none', zIndex:0}}>
      {pieces.map(p => (
        <div key={p.id} style={{
          position: 'absolute',
          left: `${p.left}%`,
          top: 0,
          color: p.color,
          fontSize: p.size,
          animation: `confetti-fall ${p.duration}s linear ${p.delay}s infinite`,
          userSelect: 'none',
        }}>
          {p.shape}
        </div>
      ))}
    </div>
  );
}

export default function CelebrationScreen({ onPlayAgain }) {
  const [danceTick, setDanceTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setDanceTick(t => t + 1), 400);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (window.speechSynthesis) {
      const utt = new SpeechSynthesisUtterance('Yay! You found all my toys!');
      utt.rate = 0.85;
      utt.pitch = 1.3;
      window.speechSynthesis.speak(utt);
    }
  }, []);

  return (
    <div style={{
      position: 'relative',
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(160deg, #FFF9C4 0%, #B3E5FC 100%)',
      overflow: 'hidden',
      gap: 20,
    }}>
      <Confetti/>

      {/* Title */}
      <div
        className="anim-fade-in-up"
        style={{
          background: '#FFD600',
          border: '5px solid #111',
          borderRadius: 24,
          padding: '12px 36px',
          boxShadow: '6px 6px 0 #111',
          zIndex: 1,
        }}
      >
        <h1 style={{
          fontFamily: "'Fredoka One', cursive",
          fontSize: 'clamp(1.6rem, 5vw, 2.8rem)',
          margin: 0,
          color: '#111',
          textAlign: 'center',
        }}>
          🎉 Yay! You found all my toys!
        </h1>
      </div>

      {/* Max dancing */}
      <div style={{zIndex:1}}>
        <MaxCharacter state="dancing" danceTick={danceTick}/>
      </div>

      {/* Toy row */}
      <div style={{
        display: 'flex',
        gap: 16,
        zIndex: 1,
        flexWrap: 'wrap',
        justifyContent: 'center',
      }}>
        {words.map(w => (
          <div
            key={w.id}
            className="anim-toy-appear"
            style={{
              width: 72,
              height: 72,
              background: 'white',
              border: '4px solid #111',
              borderRadius: 16,
              boxShadow: '4px 4px 0 #111',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 6,
            }}
          >
            <ToyImage toyId={w.id}/>
          </div>
        ))}
      </div>

      {/* Play again */}
      <button
        onClick={onPlayAgain}
        style={{
          fontFamily: "'Fredoka One', cursive",
          fontSize: 'clamp(1.2rem, 3vw, 1.8rem)',
          background: '#4CAF50',
          color: 'white',
          border: '5px solid #111',
          borderRadius: 50,
          padding: '14px 48px',
          cursor: 'pointer',
          boxShadow: '5px 5px 0 #111',
          zIndex: 1,
          transition: 'transform 0.1s, box-shadow 0.1s',
        }}
        onMouseDown={e => { e.currentTarget.style.transform='translate(3px,3px)'; e.currentTarget.style.boxShadow='2px 2px 0 #111'; }}
        onMouseUp={e   => { e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow='5px 5px 0 #111'; }}
      >
        ▶ Play Again
      </button>
    </div>
  );
}
